import { rosterSerializer } from '@/providers/serializers/roster/roster';
import { http } from '../http';

export class RosterAPI {

    private static INSTANCE = new RosterAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace = 'api/admin/v1';

    private namespace1 = 'api/nucleus-oneroster/v1';

    private uploadNamespace = 'api/nucleus-oneroster/v1p1';

    private groupsNamespace = 'api/missioncontrol/v1/groups';

    public getOrgsDetails(params: any) {
        const endpoint =  `${this.namespace}/roster/orgs`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public fetchRosterOrgs(params: any) {
        const endpoint =  `${this.namespace1}/orgs`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }


    public getUsersDetails(param: any) {
        const endpoint =  `${this.namespace}/roster/users`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, param).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }


    public getRosterUsers(param: any) {
        const endpoint =  `${this.namespace1}/users`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, param).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getAcademicSession() {
        const endpoint =  `${this.namespace1}/academicSessions`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getClassesDetails(params: any) {
        const endpoint =  `${this.namespace}/roster/classes`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return rosterSerializer.normalizeClassList(response.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getEditClasses(classId: any, params: any) {
        const endpoint =  `api/v1/admin-utils/class/${classId}/setting`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getRosterClass(params: any) {
        const endpoint =  `${this.namespace1}/classes`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }


    public getEnrollmentDetails(params: any) {
        const endpoint =  `${this.namespace1}/enrollments`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getCoursesDetails(params: any) {
        const endpoint =  `${this.namespace1}/courses`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public uploadRoster(file: any) {
        const formData = new FormData();
        formData.append('file', file);
        const endpoint =  `${this.uploadNamespace}/upload`;
        const header = http.getTokenHeaders();
        header['Content-Type'] = 'multipart/form-data';
        return http.postFile(endpoint, header, formData);
    }

    public uploadCustomRoster(file: any, userId: any, tenantId: any, type: any) {
        const formData = new FormData();
        formData.append('file', file);
        const endpoint =  `${this.namespace}/custom/roster/upload?userId=${userId}&tenantId=${tenantId}&fileUploadType=${type}`;
        const header = http.getTokenHeaders();
        header['Content-Type'] = 'multipart/form-data';
        return http.postFile(endpoint, header, formData);
    }

    public uploadRosterOldVersion(file: any) {
        const formData = new FormData();
        formData.append('file', file);
        const endpoint =  `${this.namespace1}/upload`;
        const header = http.getTokenHeaders();
        header['Content-Type'] = 'multipart/form-data';
        return http.postFile(endpoint, header, formData);
    }

    public fetchRosterUploads(params: any) {
        const endpoint = `${this.namespace1}/roster/uploads`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return  rosterSerializer.normalizeRosterList(response.data);
        });
    }

    public fetchCountriesList() {
        const endpoint = `${this.namespace}/roster/countries`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return rosterSerializer.normalizeCountries(response.data);
        });
    }

    public fetchStates(params: any) {
        const endpoint = `${this.namespace}/roster/states`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return  rosterSerializer.normalizeStates(response.data);
        });
    }

    public fetchUserAcl(params: any) {
        const endpoint = `${this.groupsNamespace}/user/${params.userId}/tenant/${params.tenantId}/acl`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return  rosterSerializer.normalizeAcl(response.data);
        });
    }

    public getCustomRosterData() {
        const endpoint = `${window.location.origin}/stubs/roster-data.json`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
      });
    }

    public getRosterDetailsById(params: any) {
        const endpoint = `${this.namespace1}/upload/${params}/status`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return  rosterSerializer.normalizeRosterData(response.data);
        });
    }

    public getCustomRosterList(tenantId: any, userID: any, params: any, type: any) {
        const endpoint = `${this.namespace}/custom/${type}/list?tenantId=${tenantId}&userId=${userID}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return  rosterSerializer.normalizeCustomRosterData(response.data);
        });
    }

    public fetchOverallRosterStats() {
        const enpoint = `${this.namespace}/roster/stats`;
        const headers = http.getTokenHeaders();
        return http.get(enpoint, headers).then((response) => {
            return rosterSerializer.normalizeRostersStats(response.data);
        });
    }

}

export const rosterAPI = RosterAPI.instance;
